module.exports = __webpack_public_path__ + "static/media/right-arrow.be3598d3.svg";